import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { Toaster } from "@/components/ui/sonner";

export default function AppLayout({ title, subtitle, children }) {
  return (
    <div className="flex h-screen w-full overflow-hidden bg-slate-50">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        <Topbar title={title} subtitle={subtitle} />
        <main className="flex-1 overflow-auto p-4 sm:p-6" data-testid="main-content">{children}</main>
      </div>
      <Toaster richColors position="top-right" />
    </div>
  );
}
